import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { P } from '@farewill/ui'
import { IndentedRadioGroup } from 'components/form'

import FilterWrapper from '../shared/filter-wrapper'

export const OWNERSHIP_TYPE_FILTER_OPTIONS: { label: string; value: string }[] =
  [
    { value: 'all', label: 'All' },
    { value: 'owner', label: 'Owner' },
    { value: 'supervisor', label: 'Supervisor' },
  ]

export const getOwnershipTypeOptions = (disableRoleOptions: boolean) =>
  OWNERSHIP_TYPE_FILTER_OPTIONS.map((option) => ({
    ...option,
    isOptionDisabled: disableRoleOptions && option.value !== 'all',
    disabledTooltipContent:
      disableRoleOptions && option.value !== 'all'
        ? 'Select a team member'
        : undefined,
  }))

const OWNERSHIP_FILTER_KEYS: { [key: string]: string } = {
  all: 'ownerOrSupervisorAdminUserId',
  owner: 'currentOwnerId',
  supervisor: 'supervisorAdminUserId',
}

export const getOwnershipFilterParam = (
  teamMemberIds: (string | number)[],
  ownershipType?: string
): { key: string; value: (string | number)[] } | null => {
  if (!teamMemberIds.length) {
    return null
  }

  return {
    key:
      OWNERSHIP_FILTER_KEYS[ownershipType as string] ||
      OWNERSHIP_FILTER_KEYS.all,
    value: teamMemberIds,
  }
}

type Props = {
  isMyCasesView: boolean
}

export const OwnershipTypeFilter = ({
  isMyCasesView,
}: Props): React.ReactElement => {
  const { values, setFieldValue } = useFormikContext<{
    teamMemberId: string[]
    ownershipType: string
  }>()
  const hasNoTeamMembers = !isMyCasesView && !values.teamMemberId?.length

  useEffect(() => {
    if (hasNoTeamMembers && values.ownershipType !== 'all') {
      setFieldValue('ownershipType', 'all')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNoTeamMembers])

  return (
    <FilterWrapper>
      <P strong margin={[0, 0, 'XS']} size="S">
        Ownership type
      </P>
      <IndentedRadioGroup
        name="ownershipType"
        options={getOwnershipTypeOptions(hasNoTeamMembers)}
      />
    </FilterWrapper>
  )
}
